document.addEventListener('DOMContentLoaded', () => {
  const rawRoot = window.Shopify?.routes?.root;
  if (!rawRoot || rawRoot === '/') return;

  const rootUrl = new URL(rawRoot, window.location.origin);
  if (rootUrl.origin !== window.location.origin) return;

  const localePrefix = rootUrl.pathname.replace(/\/+$/, '');
  if (!localePrefix || localePrefix === '/') return;

  const explicitLocalePrefix = /^\/(?:de|en|es|fr|it|nl|pt(?:-[a-z]{2})?)(?:\/|$)/i;
  const localizedStorefrontRoute = /^\/(?:account|apps|blogs|cart|collections|gift_cards|pages|policies|products|search)(?:\/|$)/i;

  const localizeLink = (anchor) => {
    const href = anchor.getAttribute('href');
    if (!href || /^(?:#|mailto:|tel:|sms:|javascript:|data:)/i.test(href)) return;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch {
      return;
    }

    if (url.origin !== window.location.origin) return;

    const path = url.pathname;
    if (path === localePrefix || path.startsWith(`${localePrefix}/`)) return;
    if (explicitLocalePrefix.test(path)) return;

    if (path === '/') {
      url.pathname = `${localePrefix}/`;
    } else if (localizedStorefrontRoute.test(path)) {
      url.pathname = `${localePrefix}${path}`;
    } else {
      return;
    }

    anchor.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
  };

  const localizeLinks = (container = document) => {
    if (container.nodeType === Node.ELEMENT_NODE && container.matches('a[href]')) {
      localizeLink(container);
    }
    container.querySelectorAll?.('a[href]').forEach(localizeLink);
  };

  localizeLinks();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) localizeLinks(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
});